<template>
	<div class="consultarealizada puiformheader">
		<v-layout wrap>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('consultarealizada.estado')" :value="getEstado"></pui-field>
			</v-flex>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('consultarealizada.mercancia')" :value="getMercancia"></pui-field>
			</v-flex>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('consultarealizada.fecharecogida')" :value="getDiaRecogida"></pui-field>
			</v-flex>
		</v-layout>
		<v-layout wrap>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('consultarealizada.peso')" :value="getPesoSolicitado"></pui-field>
			</v-flex>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('consultarealizada.pesoLocalizado')" :value="getPesoLocalizado"></pui-field>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import PuiFormHeaderMixin from 'pui9-mixins/PuiFormHeaderMixin';

export default {
	name: 'consultarealizadaformheader',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'consultarealizada'
		};
	},
	computed: {
		getMercancia() {
			return this.model && this.model.mercancia ? this.model.mercancia : '';
		},
		getDiaRecogida() {
			return this.model && this.model.fecharecogida
				? this.$dateTimeUtils.formatDate(this.model.fecharecogida, this.$store.getters.dateFormat)
				: '';
		},
		getEstado() {
			return this.model && this.model.estado ? this.model.estado : '';
		},
		getPesoSolicitado() {
			return this.model && this.model.peso ? this.formatNumber(this.model.peso) + ' Kg' : '0 Kg';
		},
		getPesoLocalizado() {
			return this.model && this.model.pesolocalizado ? this.formatNumber(this.model.pesolocalizado) + ' Kg' : '0 Kg';
		}
	},
	methods: {
		// Override
		extendFilter(filter) {
			// Ya que es una tabla con varias vistas para que funcione correctamente se necesita indicar el modelo
			filter.model = 'consultarealizada';
			// Seteo original 1 para que la relacion CONSULTA_LOTE sea correcta ya que esta tabla requiere "original 1" para obtener la relacion original
			// filter.filter.rules.push({ field: 'original', op: 'eq', data: '1' });
		},
		formatNumber(val) {
			if (val === null) {
				return '';
			}
			const thousandSeparator = this.$store.getters.thousandSeparator;
			const decimalSeparator = this.$store.getters.decimalSeparator;
			if (val.toString().includes('.')) {
				const parts = val.toString().split('.');
				parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
				return parts.join(decimalSeparator);
			}
			return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`);
		}
	}
};
</script>

<style lang="postcss" scoped></style>

<i18n>
{
	"en": {
		"consultarealizada.mercancia": "Goods",
		"consultarealizada.fecharecogida": "Pick up date",
		"consultarealizada.estado": "Inquiry state",
		"consultarealizada.peso": "Requested weight",
		"consultarealizada.pesoLocalizado": "Localized weight"
	},
	"es": {
		"consultarealizada.mercancia": "Mercancía",
		"consultarealizada.fecharecogida": "Fecha de recogida",
		"consultarealizada.estado": "Estado consulta",
		"consultarealizada.peso": "Peso solicitado",
		"consultarealizada.pesoLocalizado": "Peso localizado"
	},
	"ca": {
		"consultarealizada.mercancia": "Mercaderia",
		"consultarealizada.fecharecogida": "Data de recollida",
		"consultarealizada.estado": "Estat consulta",
		"consultarealizada.peso": "Pes sol·licitat",
		"consultarealizada.pesoLocalizado": "Pes localitzat"
	}
}
</i18n>
